import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCoursesAction } from "../../../../../../redux/actions/coursesActions";
import { TextField } from "@mui/material";

const CoursesList = ({ formik, updateModalState, modalData }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getAllCoursesAction());
  }, [dispatch]);

  const handleSalaryChange = (index, value) => {
    const updatedCourses = modalData.courses.map((course, i) =>
      i === index ? { ...course, salary: value } : course
    );
    updateModalState("courses", updatedCourses);
  };

  console.log(modalData, "yyyyyyyyyyyy");
  return (
    <div>
      {formik.errors.courses && formik.touched.courses && (
        <small className="validation-err-message">
          {formik.errors.courses}
        </small>
      )}

      <ul className="category-list courses-li">
        {modalData?.courses?.map((item, index) => (
          <li key={item._id || index}>
            <div
              className="top"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                marginBottom: "10px",
              }}
            >
              <span style={{ fontWeight: 500 }}>{`${index + 1}. ${
                item?.course.name
              }`}</span>
              <TextField
                sx={{
                  "& input": {
                    fontSize: "12px",
                  },
                  marginTop: "10px",
                  width: '48%'
                }}
                InputLabelProps={{
                  style: {
                    fontSize: "12px",
                    color: "#3F3F3F",
                  },
                }}
                type="number"
                value={item.salary ?? ""}
                onChange={(e) =>
                  handleSalaryChange(index, e.target.valueAsNumber || "")
                }
                disabled={
                  user.role === "worker" &&
                  user?.profiles?.find(
                    (profile) => profile.profile === "salaries"
                  )?.power !== "all"
                }
                label="Bir dərsə düşən əmək haqqı"
              />
              {/* <input
                type="number"
                placeholder="Maaş"
                value={item.salary || ""}
                onChange={(e) => handleSalaryChange(index, e.target.value)}
                style={{
                  marginTop: "5px",
                  padding: "5px 8px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  width: "120px",
                  fontSize: "13px",
                }}
              /> */}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CoursesList;
